import React from "react"

import BasicSlider from 'components/slider/basic'

import "./linkCardsBlock.scss"

const LinkCardsBlock = ({ block, scrollCards }) => {

  const cards = block.linkCards.links.map((card, i) => (
    <div
      className="column is-flex is-2-desktop is-6-tablet is-6-mobile"
      key={`${i}_${card.link}`}>
      <a className="link-card" href={card.link}>
        <div
          className="image"
          style={{
            backgroundImage: `url(${card?.image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src})`
          }}>
        </div>
      </a>
    </div>
  ))

  return (
    <div className={`wp-block ${block.name.replace("/", "-")}`}>
      <div className="container">
        <div className="columns">
          <div className="column is-6 is-offset-3 has-text-centered">
            {block.heading && <h3>{block.heading}</h3>}
            {block.subHeading}
          </div>
        </div>
        {block.linkCards && (
          <div className="columns is-multiline is-flex">
            {scrollCards
              ? <BasicSlider>
                {cards}
              </BasicSlider>
              : cards
            }

          </div>
        )}

        {/*data.links ? (
          <Hyperlinks buttons={false} data={data.links} hasChevron={true} />
        ) : null */}
      </div>
    </div>

  )
}

LinkCardsBlock.defaultProps = {
  scrollCards: true
}

export default LinkCardsBlock
